<template>
  <v-app :class="dashboardThemeClass" :style="dashboardThemeStyle">
    <StandaloneCrudKeyboardShortcutsHost />
    <drawer
      :drawer="drawer"
      :sidebarColor="effectiveSidebarColor"
      :sidebarTheme="sidebarTheme"
      @drawer-toggle="drawer = $event"
      @navigation-items-change="receberMenuNavegacao"
    >
    </drawer>
    <v-main>
      <div
        @click="drawer = false"
        v-if="$vuetify.breakpoint.mobile && drawer"
        class="position-absolute drawer-state"
      ></div>
      <app-bar
        v-if="$route.name != 'Profile'"
        background="bg-transparent"
        has-bg
        @drawer-toggle="drawer = $event"
        :toggle-active="drawer"
        :navbarFixed="navbarFixed"
        :navigation-items="navigationItems"
        @toggleSettingsDrawer="toggleSettingsDrawer"
      ></app-bar>
      <app-bar
        v-else-if="$route.name == 'Profile'"
        background="bg-default"
        has-bg
        @drawer-toggle="drawer = $event"
        :toggle-active="drawer"
        :navigation-items="navigationItems"
      ></app-bar>
      <app-bar
        v-else
        background="primary"
        linkColor="rgba(0,0,0,.6)"
        @drawer-toggle="drawer = $event"
        :toggle-active="drawer"
        :navigation-items="navigationItems"
      ></app-bar>
      <Transition origin="center top" mode="out-in">
        <!-- your content here -->

        <!-- A chave do cache usa o grupo do menu ativo, que o Drawer informa ao ser criado.
             Renderizar a tela antes disso troca a chave e monta a tela duas vezes. -->
        <keep-alive
          v-if="menuNavegacaoRecebido"
          :key="dashboardKeepAliveKey"
          :max="dashboardKeepAliveMax"
        >
          <router-view :key="routeCacheKey"> </router-view>
        </keep-alive>
      </Transition>
      <content-footer
        :white-label-brand="whiteLabelBrand"
        v-if="$route.name !== 'Welcome'"
      ></content-footer>

      <!-- <v-btn
        :ripple="false"
        icon
        rounded
        color="#fff"
        width="35px"
        height="35px"
        class="
          fixed-plugin-button
          position-fixed
          btn-light
          bg-white
          text-dark
          z-index-9999
        "
        @click="showSettingsDrawer = true"
      >
        <v-icon size="20">fa fa-cog py-2</v-icon>
      </v-btn> -->

      <settings-drawer
        :showSettingsDrawer="showSettingsDrawer"
        @toggleSettingsDrawer="toggleSettingsDrawer"
        @updateSidebarColor="updateSidebarColor"
        @updateSidebarTheme="updateSidebarTheme"
        @toggleNavbarPosition="toggleNavbarPosition"
      >
      </settings-drawer>
    </v-main>
  </v-app>
</template>
<script>
// /* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

import AppBar from "@/components/AppBar.vue";
import Drawer from "@/components/Drawer.vue";
import ContentFooter from "@/components/Footer.vue";
import SettingsDrawer from "@/components/Widgets/SettingsDrawer.vue";
import StandaloneCrudKeyboardShortcutsHost from "@/components/base/Crud/StandaloneCrudKeyboardShortcutsHost.vue";
import AuthDataService from "@/services/AuthDataService";
import {
  buildMenuNavigationGroups,
  findActiveMenuLink,
} from "@/utils/menuNavigation";
import {
  getLoginRouteByBrand,
  isClientWhiteLabel,
  resolveAppWhiteLabelBrand,
  resolveWhiteLabelBrandFromTenantName,
} from "@/utils/whiteLabel";
import Axios from "axios";
import jwt_decode from "jwt-decode";
//import { Transition } from "vue2-transitions";

export default {
  components: {
    ContentFooter,
    Drawer,
    AppBar,
    SettingsDrawer,
    StandaloneCrudKeyboardShortcutsHost,
  },
  data() {
    return {
      drawer: null,
      showSettingsDrawer: false,
      sidebarColor: "info",
      sidebarTheme: "transparent",
      navbarFixed: false,
      navigationItems: [],
      menuNavegacaoRecebido: false,
      dashboardKeepAliveMax: 24,
      dashboardCacheTtlMs: 3 * 60 * 1000,
      dashboardCacheTimestamps: {},
      dashboardCacheScopeVersions: {},
      tenantChangeInProgress: false,
      tenantChangeDashboardKey: "",
      tenantChangeScopeKey: "",
    };
  },
  computed: {
    whiteLabelBrand() {
      return resolveAppWhiteLabelBrand();
    },
    isWhiteLabelDashboard() {
      return isClientWhiteLabel(this.whiteLabelBrand);
    },
    dashboardThemeClass() {
      return this.isWhiteLabelDashboard ? "white-label-dashboard" : "";
    },
    dashboardThemeStyle() {
      if (!this.isWhiteLabelDashboard) {
        return null;
      }

      const primary =
        this.whiteLabelBrand.dashboardPrimaryColor ||
        this.whiteLabelBrand.authButtonColor;
      const gradientEnd =
        this.whiteLabelBrand.dashboardPrimaryGradientEnd || primary;
      const accent = this.whiteLabelBrand.dashboardAccentColor || gradientEnd;

      return {
        "--white-label-primary": primary,
        "--white-label-primary-gradient-end": gradientEnd,
        "--white-label-accent": accent,
      };
    },
    effectiveSidebarColor() {
      return this.isWhiteLabelDashboard ? "primary" : this.sidebarColor;
    },
    currentTenantCacheKey() {
      const tenantId = this.$store.state.inquilino?.id;
      return tenantId ? `tenant-${tenantId}` : "tenant-none";
    },
    dashboardCacheVersion() {
      return this.$store.state.dashboardCacheVersion || 0;
    },
    activeMenuLink() {
      const groups = buildMenuNavigationGroups(
        this.navigationItems,
        this.$store.state.permissoes || []
      );

      return findActiveMenuLink(
        groups,
        this.$route.path,
        this.$route.meta?.groupName
      );
    },
    activeMenuCacheKey() {
      if (this.$route.name === "Welcome" || this.$route.path === "/dashboard") {
        return "home";
      }

      return (
        this.activeMenuLink?.groupTitle ||
        this.activeMenuLink?.group?.title ||
        this.$route.meta?.groupName ||
        "sem-menu"
      );
    },
    dashboardKeepAliveKey() {
      // Evita remontar o módulo atual antes da navegação final da troca.
      if (
        this.tenantChangeInProgress &&
        this.$route.path !== "/dashboard" &&
        this.tenantChangeDashboardKey
      ) {
        return this.tenantChangeDashboardKey;
      }

      return [
        `cache-${this.dashboardCacheVersion}`,
        this.currentTenantCacheKey,
        this.activeMenuCacheKey,
        `ttl-${this.dashboardCacheScopeVersion}`,
      ].join(":");
    },
    dashboardCacheScopeKey() {
      if (
        this.tenantChangeInProgress &&
        this.$route.path !== "/dashboard" &&
        this.tenantChangeScopeKey
      ) {
        return this.tenantChangeScopeKey;
      }

      return [
        `cache-${this.dashboardCacheVersion}`,
        this.currentTenantCacheKey,
        this.activeMenuCacheKey,
      ].join(":");
    },
    dashboardCacheScopeVersion() {
      return this.dashboardCacheScopeVersions[this.dashboardCacheScopeKey] || 0;
    },
    routeCacheKey() {
      return `${this.dashboardKeepAliveKey}:${
        this.$route.fullPath || this.$route.path
      }`;
    },
  },
  methods: {
    initScrollbar() {
      let isWindows = navigator.platform.startsWith("Win");
      if (isWindows) {
        initScrollbar("sidenav");
      }
    },
    toggleSettingsDrawer(value) {
      this.showSettingsDrawer = value;
    },
    receberMenuNavegacao(items) {
      this.navigationItems = items;
      this.menuNavegacaoRecebido = true;
    },
    updateSidebarColor(value) {
      this.sidebarColor = value;
    },
    updateSidebarTheme(value) {
      this.sidebarTheme = value;
    },
    toggleNavbarPosition(value) {
      this.navbarFixed = value;
    },

    ensureDashboardCacheFresh() {
      const scopeKey = this.dashboardCacheScopeKey;
      const now = Date.now();
      const cacheStartedAt = this.dashboardCacheTimestamps[scopeKey];

      if (!cacheStartedAt) {
        this.$set(this.dashboardCacheTimestamps, scopeKey, now);
        return;
      }

      if (now - cacheStartedAt <= this.dashboardCacheTtlMs) return;

      this.$set(
        this.dashboardCacheScopeVersions,
        scopeKey,
        (this.dashboardCacheScopeVersions[scopeKey] || 0) + 1
      );
      this.$set(this.dashboardCacheTimestamps, scopeKey, now);
    },

    resetDashboardCacheTracking() {
      this.dashboardCacheTimestamps = {};
      this.dashboardCacheScopeVersions = {};
      this.$nextTick(this.ensureDashboardCacheFresh);
    },

    handleTenantChangeStart() {
      if (this.tenantChangeInProgress) return;

      this.tenantChangeDashboardKey = this.dashboardKeepAliveKey;
      this.tenantChangeScopeKey = this.dashboardCacheScopeKey;
      this.tenantChangeInProgress = true;
    },

    handleTenantChangeEnd() {
      this.tenantChangeInProgress = false;
      this.tenantChangeDashboardKey = "";
      this.tenantChangeScopeKey = "";
    },

    syncDrawerWithViewport() {
      this.drawer = this.$vuetify.breakpoint.mobile ? false : null;
    },

    logout: function () {
      this.$store.dispatch("AUTH_LOGOUT").then(() => {
        const fantasia = this.$store.state.inquilino.fantasia;
        const currentBrand = resolveAppWhiteLabelBrand();
        const tenantBrand = resolveWhiteLabelBrandFromTenantName(fantasia);
        const loginBrand = isClientWhiteLabel(currentBrand)
          ? currentBrand
          : tenantBrand;

        this.$router.push(getLoginRouteByBrand(loginBrand));
      });
    },

    deveFazerRefreshToken: function () {
      if (!this.$store.getters.isAuthenticated) return false;

      var epoch = jwt_decode(this.$store.state.token).exp;
      var expiracao = new Date(0);
      expiracao.setUTCSeconds(epoch);

      var agora = new Date();
      var horaRefresh = new Date(agora.getTime() + 20 * 60000);

      return horaRefresh > expiracao && expiracao > agora;
    },
  },
  mounted() {
    this.initScrollbar();
    window.addEventListener(
      "cajupe:tenant-change-start",
      this.handleTenantChangeStart
    );
    window.addEventListener(
      "cajupe:tenant-change-end",
      this.handleTenantChangeEnd
    );
  },

  beforeDestroy() {
    window.removeEventListener(
      "cajupe:tenant-change-start",
      this.handleTenantChangeStart
    );
    window.removeEventListener(
      "cajupe:tenant-change-end",
      this.handleTenantChangeEnd
    );
  },

  watch: {
    "$vuetify.breakpoint.mobile"() {
      this.syncDrawerWithViewport();
    },
    "$route.fullPath": {
      immediate: true,
      handler() {
        this.ensureDashboardCacheFresh();
      },
    },
    dashboardCacheScopeKey() {
      this.ensureDashboardCacheFresh();
    },
    dashboardCacheVersion() {
      this.resetDashboardCacheTracking();
    },
  },

  created() {
    this.syncDrawerWithViewport();
    document.addEventListener("tutorialAction", (event) => {
      if (event.detail?.action == "breakAll") {
        this.$store.dispatch("SET_PENDING_TUTORIAL", null);
      }
    });

    const deveRedirecionar = () => {
      var epoch = jwt_decode(this.$store.state.token).exp;
      var expiracao = new Date(0);
      expiracao.setUTCSeconds(epoch);

      if (expiracao < new Date()) {
        return true;
      } else {
        return false;
      }
    };

    Axios.interceptors.response.use(undefined, (err) => {
      if (deveRedirecionar()) {
        // if you ever get an unauthorized, logout the user
        this.logout();
        // you can also redirect to /login if needed !
      }
      throw err;
    });

    Axios.interceptors.response.use(
      (response) => {
        if (this.deveFazerRefreshToken()) {
          AuthDataService.refreshToken().then((response) => {
            this.$store.commit("SET_TOKEN", response.headers.authorization);
          });
        }

        return response;
      },

      function (error) {
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        // Do something with response error

        return Promise.reject(error);
      }
    );
  },
};
</script>
<style lang="scss">
.v-main:not(.auth-pages) > .v-main__wrap {
  min-width: 0;
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}

.overlay {
  top: 0;
  left: 0;
  z-index: 100;
  background-color: rgba(0, 0, 0, 0.5);
  position: absolute;
  width: 100%;
  height: 100%;
}

/* Tema dinâmico aplicado somente ao dashboard de clientes white-label. */
.white-label-dashboard .primary,
.white-label-dashboard .bg-primary,
.white-label-dashboard .btn-primary {
  border-color: var(--white-label-primary) !important;
  background-color: var(--white-label-primary) !important;
}

.white-label-dashboard .primary--text,
.white-label-dashboard .text-primary,
.white-label-dashboard .badge-primary {
  color: var(--white-label-primary) !important;
  caret-color: var(--white-label-primary) !important;
}

.white-label-dashboard .border-primary,
.white-label-dashboard .btn-outline-primary {
  border-color: var(--white-label-primary) !important;
}

.white-label-dashboard .btn-outline-primary {
  color: var(--white-label-primary) !important;
}

.white-label-dashboard .bg-gradient-primary,
.white-label-dashboard .btn-primary.bg-gradient-primary,
.white-label-dashboard .text-gradient.text-primary {
  background-color: var(--white-label-primary) !important;
  background-image: linear-gradient(
    310deg,
    var(--white-label-primary),
    var(--white-label-primary-gradient-end)
  ) !important;
}

.white-label-dashboard svg.text-primary .color-foreground {
  fill: var(--white-label-primary) !important;
}

.white-label-dashboard svg.text-primary .color-background {
  fill: var(--white-label-primary-gradient-end) !important;
}

.white-label-dashboard
  .v-navigation-drawer[data-color="primary"]
  .v-list-item.v-list-item--active
  .v-list-item__icon.shadow {
  background-color: var(--white-label-primary) !important;
  background-image: linear-gradient(
    310deg,
    var(--white-label-primary),
    var(--white-label-primary-gradient-end)
  ) !important;
}

.white-label-dashboard
  .v-navigation-drawer
  .v-list-item--active
  .v-list-item-mini
  + .v-list-item__content::before {
  background: var(--white-label-accent) !important;
}

.white-label-dashboard
  .v-navigation-drawer
  .v-list-group--active
  > .v-list-group__header
  .v-list-item__title,
.white-label-dashboard
  .v-navigation-drawer
  .v-list-group--active
  > .v-list-group__header
  .v-list-group__header__append-icon
  .v-icon,
.white-label-dashboard
  .v-navigation-drawer
  .v-list-item.v-list-item--active
  .v-list-item-mini,
.white-label-dashboard
  .v-navigation-drawer
  .v-list-item.v-list-item--active
  .v-list-item__title {
  color: var(--white-label-primary) !important;
}

.white-label-dashboard .v-tabs-slider.primary {
  border-color: var(--white-label-accent) !important;
  background-color: var(--white-label-accent) !important;
}

.white-label-dashboard
  .v-input--is-focused:not(.error--text)
  .v-input__slot
  fieldset {
  border-color: var(--white-label-accent) !important;
}
</style>
